import React, { useEffect, useState } from 'react';
import { Card, Empty, Row, Col, Input, Space } from 'antd';
import styles from '@/common/Layout/index.module.less';
import { useDispatch } from 'react-redux';
import { getMiscellaneous } from '../redux/slice';
import CustomTable from 'common/Content/CustomTable';
import Layout from '@/common/Layout';
import FormItem from '@/common/FormItem';
import { history } from 'app/history';
import {
  // CloseOutlined,
  EyeOutlined,
  // FormOutlined,
  PlusOutlined,
  SearchOutlined
} from '@ant-design/icons';
import CustomButton from '@/common/CustomButton';

const MiscellaneousListPage = ({ loading }) => {
  const dispatch = useDispatch();
  const [productsData, setProductsData] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState();
  const [search, setSearch] = useState('');

  useEffect(() => {
    handleGetMiscellaneousLabels();
  }, [page, search]);

  const handleGetMiscellaneousLabels = () => {
    const payload = { page, search };
    dispatch(getMiscellaneous(payload)).then((res) => {
      if (res.payload.success) {
        setProductsData(res.payload.data);
        setPagination(res.payload.pagination);
      }
    });
  };
  const handleChange = (e) => {
    console.log(e);
    setSearch(e.target.value);
  };

  const columns = [
    {
      title: 'Container #',
      dataIndex: 'msc_containers',
      key: 'msc_containers',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Tare Weight',
      dataIndex: 'tare_wt',
      key: 'tare_wt',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Net Weight',
      dataIndex: 'net_wt',
      key: 'net_wt',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Gross Weight',
      dataIndex: 'gross_wt',
      key: 'gross_wt',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Action',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => {
        {
          return (
            <Space>
              <a href={`/createMiscellaneous?id=${record.id}`}>
                <EyeOutlined />
              </a>
              {/* <a href={`/createLabel?id=${record.id}`}>
                <FormOutlined />
              </a> */}
              {/* <Popconfirm
                title={`Are you sure do you want to Inactive this Product batch`}
                visible={visibility(record)}
                key={record.id}
                onConfirm={(e) => {
                  e.stopPropagation();
                  handleDeleteUser({
                    id: record.id
                  });
                }}
                onCancel={(e) => {
                  e.stopPropagation();
                  setShowDisablePopup({ [record.id]: false });
                }}
                okText={record.is_active ? 'Deactivate' : 'Activate'}
                cancelText="No"
                okButtonProps={{
                  type: record.is_active ? 'danger' : 'primary'
                }}
              >
                <CloseOutlined />
              </Popconfirm> */}
            </Space>
          );
        }
      }
    }
  ];
  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no material requests to display
        </div>
      </span>
    )
  };

  return (
    <>
      <Layout sider={false}>
        <Row gutter={24}>
          <Col span="18"></Col>
          <Col span="6">
            <Input
              onChange={(e) => handleChange(e)}
              className={`w-100 ${styles.searchbar}`}
              justify="start"
              align="start"
              placeholder="Search by Container#"
              prefix={<SearchOutlined />}
            />
          </Col>
        </Row>

        <Card
          title="Miscellaneous Label Generation"
          className={`${styles.cardStyles_approver}`}
          extra={
            <Space size={8}>
              <CustomButton
                type="primary"
                onClick={() => window.location.replace('/createMiscellaneous')}
              >
                <PlusOutlined /> Generate miscellaneous labels
              </CustomButton>
            </Space>
          }
        >
          <CustomTable
            locale={locale}
            loading={loading}
            columns={columns}
            dataSource={productsData}
            pagination={{
              size: 'small',
              total: pagination?.total_records || 0,
              showSizeChanger: false,
              onChange: (page) => {
                setPage(page);
              }
            }}
            className={styles.scrolling}
            // scroll={{ x: 'auto' }}
          />
          {/* </div> */}
        </Card>
        <br />
        <FormItem className="text-center">
          <CustomButton
            className={styles.inwardButton}
            onClick={() => history.push('/landingpage')}
            type="primary"
          >
            Back to Home
          </CustomButton>
        </FormItem>
      </Layout>
    </>
  );
};
export default MiscellaneousListPage;
